module.exports = __webpack_public_path__ + "f12eae93390a6e1f5904c99d1d7f1cd7.svg";